export class CampusInfo {
    public id: number;
    public name: string;
    public info: string;
}

// Campus Info
export const CAMPUS_INFOS: CampusInfo[] = [
	{
		"id": 1,
		"name": "HELEN Campus",
		"info": "F3 Block B Charmington La Pointe<br>181 Cao Thang<br>Wd.12 | District 10<br>HCMC | Vietnam<br>T: +84 28 6278 2628<br><br>info@nascorp.vn<br>www.nascorp.vn<br>"
	},
];


// WEBPACK FOOTER //
// ./src/common/modules/core/models/CampusInfo.ts